import styled, { StyledComponentClass } from 'styled-components';
import { Box, ITheme } from '@lce/slice-ui';
import { mediaQueries } from '@lce/slice-ui/variables';
import { IBoxProps } from '@lce/slice-ui/Box/Box';

type TSizes = 'xl' | 'lg' | 'md' | 'sm';

interface IBannerBox extends IBoxProps {
  size?: TSizes;
}

const sizes = {
  xl: '1280px',
  lg: '1080px',
  md: '960px',
  sm: '816px',
};

const getSize = ({ size }: { size: TSizes }): { maxWidth: string } => ({
  maxWidth: sizes[size],
});

export const Banner = styled.div`
  background-color: ${({ theme }: ITheme) => theme.colors.orange};
  padding: 16px 16px 0;
  margin-bottom: 16px;
`;

export const BannerBox: StyledComponentClass<IBannerBox, ITheme> = styled(Box)`
  ${ getSize }
  margin: 0 auto;
  overflow: hidden;

  @media ${ mediaQueries.medium } {
    flex-direction: row;
    text-align: left;
  }
`;

export const Mascot = styled.div`
  flex: 1;
  flex-basis: auto;

  @media ${ mediaQueries.medium } {
    align-self: flex-end;
    margin-right: 48px;
  }
`;

export const Content = styled.div`
  margin-bottom: 20px;
  width: 100%;

  @media ${ mediaQueries.medium } {
    margin-bottom: 8px;
  }
`;
